<!--
 * @Description: 审批记录
 * @Version: 4.3
 * @Author: 赵轮 zhaolun@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="approval-record-col-page">
    <special-head title="审批记录"> </special-head>
    <special-table :checkedParams="{ width: 38 }" :columns="columns" :data="dataList" :pagination="pagination" @paginationEvent="onPaginationEvent" :loading="data.loading">
      <template #statusName="{ row }">
        <span :style="{ color: row.statusName == '审批中' ? 'rgb(var(--warning-6))' : row.statusName == '通过' ? 'rgb(var(--success-6))' : row.statusName == '拒绝' ? 'rgb(var(--danger-7))' : row.statusName == '撤回' ? 'rgb(var(--danger-4))' : row.statusName == '删除' ? 'rgb(var(--link-6))' : '' }">{{ row.statusName }}</span>
      </template>
      <template #rejectReason="{ row }">
        <span>{{ row.statusName == '拒绝' ? row.rejectReason || '-' : '-' }}</span>
      </template>
      <template #operation="{ row }">
        <jw-link @click="cancelApproval(row?.id)" v-if="row?.statusName == '审批中' && isShowCance">撤回</jw-link>
        <jw-link v-if="row?.showUrl && isShow && data.permission && data.permission == 1" :href="row?.showUrl" target="_blank" style="color: rgb(var(--link-6))">{{ $t('查看') }}</jw-link>
        <template v-else>-</template>
      </template>
      <template #user="{ value }">
        <xl-avatar v-if="value" :size="24" :avatar="{ name: value.userName, url: value.avatar, id: value.userId }" />
        <template v-else>-</template>
      </template>
    </special-table>
  </div>
</template>
<script setup>
import { setService, layoutService } from '@/api/';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { reactive, ref, inject, onMounted } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { objEntityMapping } from '@/utils/const';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import SpecialTable from '@/components/fh-detail/components/special-table/index.vue';

import useFhSpecialTable from '@/hooks/fh-special-table';

const { userInfo } = useUserStore(); //用户信息
const isShow = ref(false);
const isShowCance = ref(false);
const data = reactive({
  approvalRecord: [],
  id: inject('detailParams')?.id,
  entity: inject('detailParams')?.entity,
  permission: inject('detailParams')?.permission, //协作人权限
  loading: false
});
const { t } = useI18n();
// 表格头部标题
const columns = ref([
  {
    title: t('提交时间'),
    colKey: 'gmtCreated',
    width: 180
  },
  {
    title: t('审批归属人'),
    colKey: 'attributedUser',
    width: 130,
    slotName: 'user',
    description: t('发起审批后，飞书侧飞书审批的实际提交人。')
  },
  {
    title: t('操作人'),
    colKey: 'operateUser',
    width: 130,
    slotName: 'user',
    description: t('烽火侧发起审批的实际操作人（与审批归属人可能非同一人员）。')
  },
  {
    title: t('当前审批节点'),
    colKey: 'name',
    width: 180
  },
  {
    title: t('审批编号'),
    colKey: 'typeObject',
    width: 180
  },
  {
    title: t('审批状态'),
    colKey: 'statusName',
    slotName: 'statusName',
    width: 100
  },
  {
    title: t('审批完成时间'),
    colKey: 'endTime',
    width: 180
  },
  {
    title: t('拒绝理由'),
    colKey: 'rejectReason',
    slotName: 'rejectReason',
    width: 120
  },
  { title: t('操作'), colKey: 'operation', width: 80, slotName: 'operation', fixed: 'right' }
]);
//表格

const requestParams = {
  businessId: data.id,
  entityType: data.entity
};

const { pagination, onPaginationEvent, getDataList, dataList } = useFhSpecialTable(requestParams, setService.getApproveRecord.bind(setService));

onMounted(async () => {
  getDataList();
  await getDetail();
  getIsShow();
});
const props = defineProps({
  moduleId: {
    type: String,
    default: ''
  }
});
const buttons = ref([]);
const getIsShow = () => {
  let _isShow = false;
  const approvalRecordsKey = `${objEntityMapping[data.entity]}:approvalRecords`;
  const dataEntityKey = `${data.entity}:approvalRecords`;

  if ((userInfo?.roles?.includes(approvalRecordsKey) && buttons.value.includes(approvalRecordsKey)) || (userInfo?.roles?.includes(dataEntityKey) && buttons.value.includes(dataEntityKey))) {
    _isShow = true;
  }

  isShow.value = _isShow;

  let _isShowcance = false;
  const cancelApprovedKey = `${objEntityMapping[data.entity]}:cancelApproved`;
  const dataEntityCancelApprovedKey = `${data.entity}:cancelApproved`;
  if ((userInfo?.roles?.includes(cancelApprovedKey) && buttons.value.includes(cancelApprovedKey)) || (userInfo?.roles?.includes(dataEntityCancelApprovedKey) && buttons.value.includes(dataEntityCancelApprovedKey))) {
    _isShowcance = true;
  }
  isShowCance.value = _isShowcance;
};

const getDetail = async () => {
  if (!props?.moduleId) {
    return false;
  }
  try {
    const params = {
      entity: data.entity,
      moduleId: props.moduleId,
      businessId: data.id,
      apiIndex: props.moduleId
    };
    const json = await layoutService.getDetail(params);
    if (!json.error) {
      const _buttons = [];
      json?.result?.map((b) => {
        _buttons.push(b.value);
      });
      buttons.value = _buttons;
    }
  } catch (e) {
    console.log(e);
  }
};

const cancelApproval = (id) => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('撤回审批'),
    content: t('请确认是否撤回该条审批？'),
    okText: t('确定'),
    cancelText: t('取消'),
    onOk: () => {
      cApprove(id);
    }
  });
};
const cApprove = async (id) => {
  try {
    const res = await setService.cancelApproval({ id });
    if (!res.error) {
      Message.success('审批已撤回');
      getDataList();
    } else {
      Message.error(res.error?.msg || '操作失败');
    }
  } catch (error) {
    console.log(error);
  }
};
</script>
<style scoped lang="less">
@import './approve-record.less';
</style>
